<template>
  <div class="title" v-if="title">{{ title }}</div>
  <el-table
    :data="tableData"
    :style="{width}"
    border
    size="small"
    :cell-style="{ padding: '12px 0' }"
    :header-cell-style="{ background: '#f5f7fa', color: '#606266', padding: '12px 0' }"
  >
    <el-table-column prop="platformType" label="平台类型" width="180"></el-table-column>
    <el-table-column prop="platform" label="平台名称"></el-table-column>
    <el-table-column label="优惠有效期" width="280">
      <template v-slot="scope">
        <span v-if="scope.row.buy">{{ scope.row.expiresDate }}</span>
        <div v-else class="not-buy">未购买，前往购买¥199，或升级联合会员</div>
      </template></el-table-column>
    <el-table-column prop="email" label="账号绑定操作">
      <template v-slot="scope">
        <div v-if="!scope.row.bind" class="unbind-container">
          <el-icon :size="14">
            <Edit />
          </el-icon>
          <div class="unbind">未绑定</div>
        </div>
        <div v-if="scope.row.bind" class="bind-container">
          <el-icon :size="14">
            <CircleCheck />
          </el-icon>
          <div class="bind">已绑定</div>
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="学习入口">
      <template v-slot="scope">
        <el-button v-if="scope.row.buy && scope.row.platformCode != 'all'" size="mini" type="text" @click="toZmv(scope.row.platformCode)" class="access-now">立即访问</el-button>
        <el-button v-else size="mini" type="text" @click="toBuy(scope.row.platformCode)" class="access-now">立即购买</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script setup>

import { getPricePackageList } from '@/api/order';
import { onMounted, ref } from 'vue';
import { ElMessage } from 'element-plus'

const defineProps = defineProps({
  title: {
    type: String,
    default: '联合会员账号绑定列表'
  },
  width: {
    type: String,
    default: '1080px'
  },
  buyClick: {
    type: Function,
    required: true
  }
})
const tableData = ref([])

const toZmv = (platformCode)=>{
  if(platformCode === '20250330111183747383'){
    window.location.href='/zmsl'
  }else if(platformCode === '20250330111112348134'){
    ElMessage({ message: '敬请期待', type: 'success' })
  }else if(platformCode === '20250330111112384652'){
    ElMessage({ message: '敬请期待', type: 'success' })
  }
}

const toBuy = (platformCode)=>{
  // TODO 需添加'立即购买'的逻辑
  console.log('立即购买', platformCode)
  defineProps.buyClick(platformCode)
  
}

// [
//   {
//     id: '1',
//     type: '成长发展规划',
//     name: '智领',
//     phone: '2026-01-01',
//     email: 0,
//     status: 1
//   },
//   {
//     id: '2',
//     type: '软件编程课程',
//     name: '智码',
//     phone: null,
//     email: null,
//     status: null
//   },
//   {
//     id: '3',
//     type: '智能学习中心',
//     name: '智学',
//     phone: null,
//     email: 1,
//     status: null
//   },
//   {
//     id: '4',
//     type: '联合会员',
//     name: '联合会员',
//     phone: null,
//     email: 1,
//     status: null
//   }
// ]

// const toZmv = ()=>{
//   if (window.localStorage.getItem('token') === '13800000000') {
//     return;
//   } else if (window.localStorage.getItem('token') === '13800000001') {
//     window.location.href='/zmv'
//   } else if (window.localStorage.getItem('token') === '13800000002') {
//     window.location.href='/zmv'
//   }
  
// }

onMounted(()=>{
  getPricePackageList().then(response => {
    const res = response.data;
    if(res.code === 200){
      tableData.value = res.data
    }
  })
})

</script>
<style scoped>
.title {
  width: 1080px;
  text-align: left;
  font-size: 20px;
}
.not-buy {
  color: #fff;
  background-color: #FF5340;
  border-radius: 8px;
  padding: 2px 8px;
  font-size: 12px;
  width: fit-content;
}
.unbind-container {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px dashed #DCDFE6;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 16px;
}
.bind-container {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 16px;
  background-color: #61E054;
  color: #fff;
}
.el-table {
  font-size: 18px;
}
.access-now {
  font-size: 16px;
}
</style>